import { creators } from '@/mocks/home';

export default function CreatorHighlights() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            优质创作者
          </h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto">
            发现你喜爱的内容创作者，关注他们获取最新动态
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {creators.map((creator) => (
            <div
              key={creator.name}
              className="group flex flex-col items-center p-5 rounded-xl bg-background-50 hover:bg-background-50 transition-all duration-200 cursor-pointer"
            >
              <div className="relative mb-3">
                <img
                  src={creator.avatar}
                  alt={creator.name}
                  className="w-20 h-20 rounded-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-check-line text-background-50 text-xs"></i>
                </div>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{creator.name}</span>
              <span className="text-xs text-foreground-400 mt-1">{creator.followers}粉丝</span>
              <span className="text-xs text-foreground-400">{creator.videos}个视频</span>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-secondary-300 text-foreground-700 hover:bg-secondary-50 text-sm transition-colors cursor-pointer whitespace-nowrap">
            发现更多创作者
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}